/* Sticky variant bridge 2026-09-08 */
document.addEventListener('change',function(e){if(!e.target.matches('[data-sticky-variant-select]'))return;var root=e.target.closest('[data-kf-product-root]')||document;var parts=(e.target.options[e.target.selectedIndex].text||'').split('/').map(function(v){return v.trim()});root.querySelectorAll('[data-option-group]').forEach(function(group,index){var wanted=parts[index];var button=Array.from(group.querySelectorAll('[data-option-value]')).find(function(b){return b.dataset.optionValue===wanted});if(button)button.click()})});

(() => {
  const formatMoney = (amount, currency, locale) => {
    try {
      return new Intl.NumberFormat(locale || 'ja-JP', {
        style: 'currency',
        currency: currency || 'JPY',
        minimumFractionDigits: currency === 'JPY' ? 0 : 2,
        maximumFractionDigits: currency === 'JPY' ? 0 : 2,
      }).format(amount / 100);
    } catch (_) {
      return `¥${Math.round(amount / 100).toLocaleString('ja-JP')}`;
    }
  };

  const initSection = (root) => {
    if (!root || root.dataset.kfInitialized === 'true') return;
    root.dataset.kfInitialized = 'true';

    const mediaItems = [...root.querySelectorAll('[data-media-id]')].filter((item) => item.classList.contains('kfep__media'));
    const mediaButtons = [...root.querySelectorAll('[data-media-button]')];
    const currentMedia = root.querySelector('[data-current-media]');
    const form = root.querySelector('[data-kf-product-form]');
    const variantsNode = root.querySelector('[data-product-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const optionGroups = [...root.querySelectorAll('[data-option-group]')];
    const variantInput = root.querySelector('[data-variant-id]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const addLabel = root.querySelector('[data-add-label]');
    const addPrice = root.querySelector('[data-add-price]');
    const price = root.querySelector('[data-price]');
    const comparePrice = root.querySelector('[data-compare-price]');
    const saleBadge = root.querySelector('[data-variant-sale]');
    const stockLabel = root.querySelector('[data-stock-label]');
    const sticky = root.querySelector('[data-sticky-buy]');
    const stickySubmit = root.querySelector('[data-sticky-submit]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const stickyVariant = root.querySelector('[data-sticky-variant]');
    const currency = root.dataset.currency || 'JPY';
    const locale = root.dataset.locale || 'ja-JP';

    const activateMedia = (id, index) => {
      if (!id) return;
      mediaItems.forEach((item) => {
        const active = String(item.dataset.mediaId) === String(id);
        item.classList.toggle('is-active', active);
        item.hidden = !active;
      });
      mediaButtons.forEach((button) => {
        const active = String(button.dataset.mediaId) === String(id);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        if (active && currentMedia) currentMedia.textContent = String(button.dataset.mediaIndex || index || 1).padStart(2, '0');
      });
    };

    mediaButtons.forEach((button) => button.addEventListener('click', () => {
      const index = Number(button.dataset.mediaIndex || 1);
      activateMedia(button.dataset.mediaId, index);
    }));

    const selectedOptions = () => optionGroups.map((group) => group.querySelector('[data-option-value].is-selected')?.dataset.optionValue || '');
    const findVariant = () => {
      const values = selectedOptions();
      return variants.find((variant) => variant.options.every((value, index) => value === values[index]));
    };

    const updateOptionAvailability = () => {
      const selected = selectedOptions();
      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          const candidate = [...selected];
          candidate[groupIndex] = button.dataset.optionValue;
          const possible = variants.some((variant) => variant.available && variant.options.every((value, index) => index === groupIndex ? value === candidate[index] : !candidate[index] || value === candidate[index]));
          button.disabled = !possible;
          if (!possible) button.setAttribute('aria-label', `${button.dataset.optionValue} 売り切れ`);
          else button.removeAttribute('aria-label');
        });
      });
    };

    const updateVariant = (variant) => {
      const available = Boolean(variant?.available);
      if (variantInput) variantInput.value = variant?.id || '';
      if (price) price.textContent = variant ? formatMoney(variant.price, currency, locale) : '';
      if (addPrice) addPrice.textContent = variant ? formatMoney(variant.price, currency, locale) : '';
      if (stickyPrice) stickyPrice.textContent = variant ? formatMoney(variant.price, currency, locale) : '';
      if (comparePrice) {
        const showCompare = variant && variant.compare_at_price > variant.price;
        comparePrice.hidden = !showCompare;
        comparePrice.textContent = showCompare ? formatMoney(variant.compare_at_price, currency, locale) : '';
      }
      if (saleBadge) {
        const showSale = variant && variant.compare_at_price > variant.price;
        saleBadge.hidden = !showSale;
        if (showSale) saleBadge.textContent = `${Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}% OFF`;
      }
      if (addButton) addButton.disabled = !available;
      if (stickySubmit) stickySubmit.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'カートに追加' : '売り切れ';
      if (stickySubmit) stickySubmit.querySelector('span').textContent = available ? 'カートに追加' : '売り切れ';
      if (stockLabel) stockLabel.textContent = available ? '在庫あり' : '売り切れ';
      if (stickyVariant) stickyVariant.textContent = variant?.title || '';
      if (variant?.featured_media?.id) activateMedia(variant.featured_media.id);
      if (variant?.id && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      root.dispatchEvent(new CustomEvent('kf:variant-change', { bubbles: true, detail: { variant } }));
    };

    optionGroups.forEach((group) => {
      group.querySelectorAll('[data-option-value]').forEach((button) => button.addEventListener('click', () => {
        if (button.disabled) return;
        group.querySelectorAll('[data-option-value]').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        const label = group.querySelector('[data-option-label]');
        if (label) label.textContent = button.dataset.optionValue;
        updateOptionAvailability();
        updateVariant(findVariant());
      }));
    });

    updateOptionAvailability();
    updateVariant(findVariant() || variants.find((variant) => String(variant.id) === String(variantInput?.value)) || variants[0]);

    if (form && addButton) {
      form.addEventListener('submit', () => {
        addButton.classList.add('is-loading');
        addButton.setAttribute('aria-busy', 'true');
      });
    }

    if (sticky && addButton && 'IntersectionObserver' in window) {
      const stickyObserver = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: .2 });
      stickyObserver.observe(addButton);
    }

    const revealItems = root.querySelectorAll('[data-kf-reveal]');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.classList.add('kf-motion-ready');
      const revealObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      }), { threshold: .1, rootMargin: '0px 0px -4% 0px' });
      revealItems.forEach((item) => revealObserver.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-kf-editorial-product]').forEach(initSection);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
